<template>
    <div class=""  ref="content">
        <div class="margin_top_100">
            <div class="inner" style="padding-bottom:64px;box-sizing:border-box">
                <div>
                    <div class="ingredientlistcontain display_flex justify-content_flex-justify align-items_center">
                       <div ><span class="lineheight_42">在全部 {{ingredientlists.length}} 种成分中筛选：</span>
                        <div  v-if="choosedName!=''" :class="['effencyItem','active']"  @click="filterOneWord({})">{{choosedName}}({{ingredientListShow.length}}种)<i class="cha"></i></div>
                       </div>
                       <span class="clearbtn" @click="filterOneWord({})">清空条件</span>
                    </div>
                </div>
                <div class="ingredient_choosed">
                   <span>成分功效：</span> 
                   <div :class="['effencyItem',choosedKey==item.key?'dark':'']" v-if="compositiondata.length >0" v-for="item in compositiondata" @click="filterOneWord(item)">{{item.name}}({{item.num}})</div>
                   <div class='effencyItem' v-if="compositiondata.length == 0"  >本类别无功效</div>
                </div>
                <div class="width_100 display_flex " style="padding:16px 0;">
                    <div class="flex_1 item_ingredient">成分名称</div>
                    <div class="flex_1 item_ingredient">使用目的</div>
                </div>
                <div class="width_100 display_flex  ingredientItem" v-for="item in ingredientListShow">
                    <div class="flex_1 contentitem_ingredient">{{item.chs_name?item.chs_name:item.eng_name}}</div>
                    <div class="flex_1 popitem_ingredient">{{item.mlxx_use_purpose}}</div>
                </div>
            </div>
        </div>
      
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.width_100{
    width: 100%;
}
.padding_bottom_64 {
    padding-bottom: 64px;
    box-sizing: border-box;
}
.margin_top_100 {
    margin-top: 100px;
}

.margin_top_32 {
    margin-top: 32px;
    box-shadow: 0;
}

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.padding-bottom-16 {
    padding: 0px 0 16px;
    box-sizing: border-box;
}

.content_bottom_L {
    display: inline-block;

    .date {
        padding-left: 6px;
        box-sizing: border-box;
        color: #888888
    }
}


.filt-box {
      width:100%;
      padding: 0 14px;
      box-sizing: border-box;
      color: #9b9b9b;
      height: 40px;
      line-height: 40px;
      /* position: fixed;
      top: 0; */
      z-index: 2;
      background-color: #fff;
      font-size: 12px;
      /* position: absolute;
      top: 60px;
      left: 0; */
    }
    .ingredient-img {
      width: 9px;
      height: 5px;
      margin-left: 5px;
      vertical-align: middle;
    }
    .inline-block{
        display: inline-block;
    }
    .floatR{
        float: right;
    }

    .ingredient-modal {
      width: 100%;
      border-bottom: 1px solid #cccccc;
      font-size: 16px;
      line-height: 42px;
      margin-top: 30px;
            
    }
    
    .selected-key{
        min-width: 110px;
        display: inline-block;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
        box-sizing: border-box;
        border:1px solid #64c8bc;
        border-radius:100px;
        background:#ffff;
        color: #64c8bc;
        cursor: pointer;
        padding: 0 8px;
    }
    .selected-key i{
            width: 10px;
            height: 10px;
            display: inline-block;
            background-repeat: no-repeat;
            background-position: center;
            /*background-image: url(../../img/close.png);*/
            margin-left: 6px;
            background-size: 100%;
            vertical-align: middle;
    }
    
    .selected-key:hover i{
        /*background-image: url(../../img/close-active.png);*/
    }
    
    .clear-btn{
        padding: 0px 12px;
        border-top: 1px solid #f7f7f7;
        background-color: #f8f8f8;
        border-bottom: 1px solid #f7f7f7;
        text-align: center;
        border-radius: 3px;
        box-sizing: border-box;
        line-height: 24px;
        display: inline-block;
        vertical-align: middle;
    }
    
    .background-grave{
        /* background-color:#F8F8F8; */
        margin-top: 24px;
        overflow: hidden;
    }
    .background-grave-item{
        
    }
    .ingredient-title{
        display: inline-block;
        line-height:40px;
        color:#969ba6;
        font-size:14px;
        /* padding-left:20px; */
        box-sizing:border-box;
        padding-bottom:5px;
        padding-top: 5px;
    }
    .ingredient-items{
        margin: 0;
        font-size: 0;
        display: inline-block;
    }
    .ingredient-items>li{
        min-width: 110px;
        display: inline-block;
        line-height: 38px;
        font-size: 14px;
        text-align: center;
        box-sizing: border-box;
        border:1px solid #e6e6e6;
        border-radius:100px;
        margin:0 0 10px 10px;
        background:#ffff;
        color: #4a4e57;
        cursor: pointer;
        padding: 0 5px;
    }
    
    .ingredient-items>li:hover{
        color: #64c8bc;
        border-color: #64c8bc;
    }
    
    .ingredient-items>li.dark{
        color: #e6e6e6;
        border-color: #e6e6e6;
        cursor: not-allowed;
    }
    
    .ingredient-table{
        min-height: 40vh;
        margin-top: 50px;
    }
    .ingredient-row {
        color: #333333;
      padding: 16px 0;
      box-sizing: border-box;
    
    }
    
    .ingredient-row:nth-child(even) {
      background-color: #F8F8F8;
    }
    
    .ingredient-col{
        /*width: 33.33%;*/
        width:50%;
        display: inline-block;
        font-size: 16px;
        text-align: center;
        padding: 0 15px;
        box-sizing: border-box;
        word-wrap: break-word;
        vertical-align: middle;
        line-height: 28px;
    }
    
    .ingredient-row.bigfont .ingredient-col{
        font-size: 20px;
        color: #555555;
    }
    
    
    .makeit-green{
        color: #64c8bc;
    }

    /*成分页*/
.ingredientlistcontain{
    width: 100%;
    border-bottom: 1px solid #cccccc;
    font-size: 16px;
    padding-top: 30px;
    color: #51515C;
}
.lineheight_42{
    line-height: 42px;
}
.clearbtn{
    padding: 0px 12px;
    border-top: 1px solid #f7f7f7;
    background-color: #f8f8f8;
    border-bottom: 1px solid #f7f7f7;
    text-align: center;
    border-radius: 3px;
    box-sizing: border-box;
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
}

.item_ingredient{
    text-align: center;
    padding: 0 15px;
    box-sizing: border-box;
    word-wrap: break-word;
    vertical-align: middle;
    line-height: 32px;
    font-size: 20px;
    color: #555555;
}

.ingredient_choosed{
    line-height: 50px;
    text-align: left;
    margin-top: 24px;
}

.contentitem_ingredient{
    text-align: center;
    padding: 0 15px;
    box-sizing: border-box;
    word-wrap: break-word;
    vertical-align: middle;
    line-height: 28px;
    font-size: 16px;
    color: #64c8bc;
}
.popitem_ingredient{
    text-align: center;
    padding: 0 15px;
    box-sizing: border-box;
    word-wrap: break-word;
    vertical-align: middle;
    line-height: 28px;
    font-size: 16px;
    color: #333;
}
.ingredientItem{
    color: #333333;
    padding: 16px 0;
    box-sizing: border-box;
    &:nth-child(even) {
        background-color: #F8F8F8;
    }
}


.effencyItem{
    min-width: 110px;
    display: inline-block;
    line-height: 38px;
    font-size: 14px;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid #e6e6e6;
    border-radius: 100px;
    margin: 0 0 10px 10px;
    background: #ffff;
    color: #4a4e57;
    cursor: pointer;
    padding: 0 5px;
    &.dark{
        color: #e6e6e6;
        border-color: #e6e6e6;
        cursor: not-allowed;
    }
    &.active{
        min-width: 110px;
        display: inline-block;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
        box-sizing: border-box;
        border: 1px solid #64c8bc;
        border-radius: 100px;
        background: #ffff;
        color: #64c8bc;
        cursor: pointer;
        padding: 0 8px;
        &:hover{
            .cha{
            width: 16px;
            height: 16px;
            margin-left: 2px;
            display: inline-block;
            vertical-align: middle;
           
                background: url('https://p1.fishqc.net/FiduK7bBlug4ddLAlM8OrvqyIB58');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                }
            
        }
        .cha{
            width: 16px;
            height: 16px;
            background: url('https://p1.fishqc.net/FrDNEhHbCnYpH5CdwP6AXgvRpJaO');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            display: inline-block;
            vertical-align: middle;
            margin-left: 2px;
           
        }
    }
}

</style>
<style type="text/css" lang="scss">

</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { ingredientlistApi} from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'

import {formatTime} from '@/utils/other.js'
import Modal from '@/components/Modal.vue'
export default {
    name: '',
    components: {
        banner,
        modal:Modal

    },
    mixins: [myMixin],
    data() {
        return {
            // 数据
            ingredientlists: [],             //成分表--全部
            ingredientListShow:[],          //成分表--部分-用于筛选
            
            compositiondata: [],            //功效列表
            securitydata: [],               //风险（安全）列表
            
            choosedKey: '',                 //筛选词关键字
            choosedName: '',                //筛选词中文名
           
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper1.$swiper
        },
        splitfun(){
            return function(str){
                return str.split(',')
                
            }
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y-M-D')
            }
        }
        
    },
    watch:{
        
        '$route' (to, from) {
            console.log(to)
            console.log(from)
            this.$router.go(0)
            //this.$forceUpdate()
        },
        'ingredientlists':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
               
            })
        },
    },
    mounted() {
        var _securitydata = window.localStorage.getItem('securitydata')?window.localStorage.getItem('securitydata'):[];
        this.securitydata = JSON.parse(_securitydata);
        var _compositiondata = window.localStorage.getItem('compositiondata')?window.localStorage.getItem('compositiondata'):[];
        this.compositiondata = JSON.parse(_compositiondata);
        
        var choosedItem = window.localStorage.getItem('choosedItem') ? JSON.parse(window.localStorage.getItem('choosedItem')): {};
        this.choosedKey = choosedItem.key ? choosedItem.key : '';
        console.log(this.choosedKey)
        this.choosedName = choosedItem.name ? choosedItem.name : '';
        this.ingredientlist()
        // this.currentlang  = window.localStorage.getItem("LOCALE") ||  'chs'
        // this.scrollToY(0, 0, 'easeInOutQuint');
       
    },
    methods: {
       
        // 推荐的产品
        ingredientlist(){
            ingredientlistApi({
                prdId:this.$route.query.prdId,
                efficacy:this.$route.query.efficacy
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.ingredientlists = res.data
                    this.updateData()
                }else if(res.code == 400){
                    this.$router.push({
                        path: '/Page404'
                    })
                }else{
                    this.ingredientlists = []
                    this.updateData()
                }
            })
        },
        filterOneWord: function(item){
            this.choosedKey = item.key ? item.key : '';
            this.choosedName = item.name ? item.name : '';
            this.updateData();
            
            //关闭弹层
            // this.filter_flag = false;
        },
        //根据筛选条件筛选结果
        updateData: function(){
            var that = this
            this.ingredientListShow = [];
            
            if(this.choosedKey == ''){
                this.ingredientListShow = this.ingredientlists;
            }else{
                this.ingredientListShow = this.ingredientlists.filter(function(el) {
                    console.log(el)
                    console.log(that.choosedKey)
                    return el[that.choosedKey]&&el[that.choosedKey];
                });
            }
            
            
            
        },
        
    }
}
</script>